module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r9n7r4r-b46d5a3098fa599f3ef4a9ed37e59305.svg";